import React from "react";
import InstagramIcon from "@material-ui/icons/Instagram";
import GitHubIcon from "@material-ui/icons/GitHub";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import MailIcon from "@material-ui/icons/Mail";

import "./Footer.css";

const Footer = () => {
  return (
    <div className="text-center mx-auto py-3 px-3 footer-area">
      <a href="https://www.instagram.com/kushal_kumar01/">
        <InstagramIcon></InstagramIcon>
      </a>
      <a href="https://github.com/K-Kumar-01">
        <GitHubIcon style={{ fontSize: "2.2rem" }}></GitHubIcon>
      </a>
      <a href="https://www.linkedin.com/in/kushal-kumar-979575170/">
        <LinkedInIcon style={{ fontSize: "2.2rem" }}></LinkedInIcon>
      </a>
      <a href="mailto:kushalkumargupta4@gmail.com">
        <MailIcon style={{ fontSize: "2.2rem" }}></MailIcon>
      </a>
    </div>
  );
};

export default Footer;
